import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { EmailValidators } from '@iot-platform/iot-platform-utils';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [TranslatePipe, ReactiveFormsModule, MatInput, MatFormFieldModule, MatButtonModule, MatIcon],
  selector: 'iot-platform-login-send-code-form',
  templateUrl: './login-send-code-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./login-send-code-form.component.scss', '../../scss/style.scss']
})
export class LoginSendCodeFormComponent {
  form = new FormGroup({
    email: new FormControl<string | null>(null, [Validators.required, EmailValidators.isValid()])
  });

  hasError = input<boolean>(false);
  isI4BLogin = input<boolean>(false);

  // eslint-disable-next-line  @angular-eslint/no-output-native
  cancel = output();
  sendCode = output<string>();

  get email(): FormControl<string | null> {
    return this.form.controls.email;
  }

  onChangeEmail(value: string) {
    this.email.setValue(value.toLowerCase());
  }

  onCancel() {
    this.cancel.emit();
  }

  onSendCode() {
    this.sendCode.emit(this.email.value ?? '');
  }
}
